import { useCallback } from 'react'
import { useQuery } from '@apollo/client'
import { forwardRef, Select, SelectProps } from '@chakra-ui/react'
import { graphql } from '@/__generated__/gql'

type Props = {
  prompt?: string
  value: string | null
  onChange: (value: string | null) => void
} & Omit<SelectProps, 'value' | 'onChange'>

export const usersDocument = graphql(`
  query UserSelect {
    users {
      results {
        id
        name
      }
    }
  }
`)

export const UserSelect = forwardRef(
  ({ prompt, value, onChange, ...rest }: Props, ref) => {
    const { data, error } = useQuery(usersDocument)
    const users = data?.users.results || []

    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange?.(e.target.value || null)
      },
      [onChange]
    )

    if (error) throw error

    return (
      <Select ref={ref} value={value ?? ''} onChange={handleChange} {...rest}>
        {prompt && <option value="">{prompt}</option>}
        {users.map((user) => (
          <option key={user.id} value={user.id}>
            {user.name}
          </option>
        ))}
      </Select>
    )
  }
)
